import { render, staticRenderFns } from "./statement-komisi-card.vue?vue&type=template&id=37d98efb&"
import script from "./statement-komisi-card.vue?vue&type=script&lang=js&"
export * from "./statement-komisi-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports